import React from 'react'
import { Menu, Dropdown, Button } from 'antd'
import { FormattedMessage } from 'react-intl'
import { INFO_EMAIL, PUBLIC_URL, WORDPRESS_URL } from 'utils/constants'
import { openInNewTab } from 'utils'
import { QuestionCircleFilled } from '@ant-design/icons'

const HelpMenu = () => {
  const menu = (
    <Menu>
      <Menu.Item>
        <a target="_blank" onClick={() => openInNewTab(`${WORDPRESS_URL}/academy/documentation`)}>
          <i className="topbar__dropdownMenuIcon icmn-file-text" />{' '}
          <FormattedMessage id="help.documentation" />
        </a>
      </Menu.Item>
      <Menu.Item>
        <a target="_blank" onClick={() => openInNewTab(`${WORDPRESS_URL}/academy/faq`)}>
          <i className="topbar__dropdownMenuIcon icmn-bubble2" /> <FormattedMessage id="help.faq" />
        </a>
      </Menu.Item>
      <Menu.Item>
        <a href={`mailto:${INFO_EMAIL}`}>
          <i className="topbar__dropdownMenuIcon icmn-mail2" />{' '}
          <FormattedMessage id="help.directSupport" />
        </a>
      </Menu.Item>
      <Menu.Item>
        <a target="_blank" onClick={() => openInNewTab(`${PUBLIC_URL}/report-bug`)}>
          <i className="topbar__dropdownMenuIcon icmn-bug" /> <FormattedMessage id="reportBug" />
        </a>
      </Menu.Item>
    </Menu>
  )

  return (
    <Dropdown overlay={menu} placement="bottomLeft">
      <Button icon={<QuestionCircleFilled className="mr-2" />} className="helpBtn">
        <FormattedMessage id="help" />
      </Button>
    </Dropdown>
  )
}

export default HelpMenu
